const AuthChoices = ({ auth, setAuth, name, t }) => {
  return (
    <div className='m-3 grid grid-cols-2 lg:mx-8 lg:my-5'>
      <button
        type='button'
        onClick={() => setAuth(name + '-mobile')}
        className={`w-full cursor-pointer rounded-s-lg border border-e-0 ${auth === name + '-mobile' ? 'border-red-600 bg-red-600 text-white' : 'border-black/30'} py-1 font-bold transition-all duration-500 hover:bg-red-600 hover:text-white max-lg:text-sm max-md:text-[16px] text-[16px] sm:py-1.5`}
      >
        {t(name + ' with Mobile')}
      </button>
      <button
        type='button'
        onClick={() => setAuth(name + '-email')}
        className={`w-full cursor-pointer rounded-e-lg border border-s-0 ${auth === name + '-email' ? 'border-red-600 bg-red-600 text-white' : 'border-black/30'} py-1 font-bold transition-all duration-500 hover:bg-red-600 hover:text-white max-lg:text-sm max-md:text-[16px] text-[16px] sm:py-1.5`}
      >
        {t(name + ' with E-Mail')}
      </button>
    </div>
  );
};

export default AuthChoices;
